import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {Questions} from "../../../questions";

@Component({
  selector: 'app-module5',
  templateUrl: './module5.component.html',
  styleUrls: ['./module5.component.scss']
})
export class Module5Component implements OnInit {
  questions: any[];
  questionnaireForm: FormGroup;

  constructor(private fb: FormBuilder,
              private http: HttpClient,
              private router: Router) {
  }

  ngOnInit() {
    this.questions = Questions;
    const formControls = this.questions
        .map(question => `question${question.nr}`)
        .reduce((acc, curr) => {
          acc[curr] = new FormControl('');
          return acc;
        }, {});
    this.questionnaireForm = this.fb.group(formControls);
  }



  openDialog(nr): void {

    document.getElementById(nr).scrollIntoView();
    // this.router.navigate(['/' + url], {fragment: nr}).then();

  }

  selectAnswer(nr, key): void {
    this.getAnswer(nr, key);
  }

  getAnswer(nr, key) {
    const answers = [];
    const val = [
      1, 1, 2, 1, 1, 1, 2, 1, 2, 2, 2, 1, 2, 1, 2, 2, 1, 2, 1, 1, 1, 2, 2, 2, 1, 2, 2, 2, 2, 2, 1, 2,
      1, 1, 1, 1, 2, 2, 1, 2, 1, 1, 1, 2, 1, 1, 1, 2, 2, 2, 1, 1, 1, 2, 1, 2, 1, 2, 2, 2, 2, 1,
      2, 2, 1, 1, 1, 1, 2, 2, 1, 2, 2, 2, 1, 1, 2, 2, 2, 1, 2, 1, 2, 1, 2, 2, 2, 1, 1, 1, 1, 1,
      1, 2, 2, 2, 2, 1, 1, 1, 2, 2, 1, 2, 2, 2, 1, 2, 1, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 2, 1, 2,
      1, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 2, 2, 1, 1, 2, 2, 1, 1, 1, 2, 2, 1, 1,
      2, 1, 2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 1, 1, 1, 2, 1, 1, 1, 2, 2, 1, 2, 1, 1, 2, 1, 1, 1,
      2, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 2, 2, 1, 1, 2, 1, 1, 1, 2, 1, 1, 1, 2, 2, 1, 1,
      1, 2, 1, 1, 2, 1, 1, 1, 1, 2, 2, 1, 1, 1, 1, 2, 1, 2, 1, 1, 1, 1, 2, 1, 2, 1, 2, 2, 1, 1];

    for (let i = 1; i <= 242; i++) {
      answers[i] = val[i - 1] - 1;
    }

    if (answers[nr] == key) {

      let list = document.getElementsByClassName('radioAnswer' + nr);
      for (let item of list) {
        item.classList.remove('danger');
      }
      document.getElementById('radioAnswer' + nr + key).classList.add('success');

    } else {
      let list = document.getElementsByClassName('radioAnswer' + nr);
      for (let item of list) {
        item.classList.remove('danger');
        item.classList.remove('success');
      }

      document.getElementById('radioAnswer' + nr + key).classList.add('danger');

    }

    this.updateResult();
  }

  updateResult(): void {
    var successLength = document.querySelectorAll('.success').length;
    var dangerLength = document.querySelectorAll('.danger').length;
    document.getElementById('successSum').innerHTML = successLength.toString();
    document.getElementById('dangerSum').innerHTML = dangerLength.toString();
  }

}
